
export enum DeliveryEventSource {
  CMA = 'CMA',
  CICO = 'CICO',
  CICO_TABLET = 'CICO_TABLET',
  CMBL = 'CMBL',
  SAP = 'SAP',
  EXTERNAL = 'EXTERNAL',
  CRON = 'CRON',
  TMS = 'TMS',
  UNKNOWN = 'UNKNOWN'
}
